export const GET_CARRIER_CONFIGURATION_LIST_REQUEST =
  "GET_CARRIER_CONFIGURATION_LIST_REQUEST";
export const GET_CARRIER_CONFIGURATION_LIST_SUCCESS =
  "GET_CARRIER_CONFIGURATION_LIST_SUCCESS";
export const GET_CARRIER_CONFIGURATION_LIST_FAILURE =
  "GET_CARRIER_CONFIGURATION_LIST_FAILURE";

export const ADD_UPDATE_CARRIER_CONFIGURATION_REQUEST =
  "ADD_UPDATE_CARRIER_CONFIGURATION_REQUEST";
export const ADD_UPDATE_CARRIER_CONFIGURATION_SUCCESS =
  "ADD_UPDATE_CARRIER_CONFIGURATION_SUCCESS";
export const ADD_UPDATE_CARRIER_CONFIGURATION_FAILURE =
  "ADD_UPDATE_CARRIER_CONFIGURATION_FAILURE";

export const GET_CARRIER_MILESTONE_LIST_REQUEST =
  "GET_CARRIER_MILESTONE_LIST_REQUEST";
export const GET_CARRIER_MILESTONE_LIST_SUCCESS =
  "GET_CARRIER_MILESTONE_LIST_SUCCESS";
export const GET_CARRIER_MILESTONE_LIST_FAILURE =
  "GET_CARRIER_MILESTONE_LIST_FAILURE";

export const GET_MILESTONE_LOOKUP_REQUEST = "GET_MILESTONE_LOOKUP_REQUEST";
export const GET_MILESTONE_LOOKUP_SUCCESS = "GET_MILESTONE_LOOKUP_SUCCESS";
export const GET_MILESTONE_LOOKUP_FAILURE = "GET_MILESTONE_LOOKUP_FAILURE";

export const ADD_UPDATE_CARRIER_MILESTONE_REQUEST =
  "ADD_UPDATE_CARRIER_MILESTONE_REQUEST";
export const ADD_UPDATE_CARRIER_MILESTONE_SUCCESS =
  "ADD_UPDATE_CARRIER_MILESTONE_SUCCESS";
export const ADD_UPDATE_CARRIER_MILESTONE_FAILURE =
  "ADD_UPDATE_CARRIER_MILESTONE_FAILURE";

export const GET_CARRIER_ACTIVITY_LIST_REQUEST =
  "GET_CARRIER_ACTIVITY_LIST_REQUEST";
export const GET_CARRIER_ACTIVITY_LIST_SUCCESS =
  "GET_CARRIER_ACTIVITY_LIST_SUCCESS";
export const GET_CARRIER_ACTIVITY_LIST_FAILURE =
  "GET_CARRIER_ACTIVITY_LIST_FAILURE";

export const GET_CARRIER_CONFIGURATION_DETAILS_REQUEST =
  "GET_CARRIER_CONFIGURATION_DETAILS_REQUEST";
export const GET_CARRIER_CONFIGURATION_DETAILS_SUCCESS =
  "GET_CARRIER_CONFIGURATION_DETAILS_SUCCESS";
export const GET_CARRIER_CONFIGURATION_DETAILS_FAILURE =
  "GET_CARRIER_CONFIGURATION_DETAILS_FAILURE";
